module.exports = __webpack_public_path__ + "media/cases-brand-tommee-lazyload-81.654d37ac.mp4";